import { EventsSection } from '../../../common/main/events/EventsSection';

export const StudentEventsPage = () => {
  return <EventsSection />;
};
